import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useEffect, useMemo, useRef } from "react"
import { Box } from "@mui/material"
import { PortalUpdated } from "lib/@components/request-page-repeat"
import { createEvent } from "library/local-events/index.mjs"

export const PaginationPortalLoaded = createEvent("PaginationPortalLoaded")

export function PaginationPortal(props) {
    const context = useBoundContext()
    const portal = useRef()
    // Prevents duplicate event raises from multiple code paths:
    // - setPortal (ref callback) fires when DOM element mounts
    // - useEffect fires after render
    // - Both could fire on initial mount, and again on re-renders with new context
    // We only want events raised once when the portal first becomes available
    const initialized = useRef(false)

    useMemo(() => {
        // Set portal reference on context (may be a new context object on re-render)
        if (portal.current) {
            context.paginationPortal = portal.current
        } else {
            context.paginationPortal = false
        }
    }, [context])

    useEffect(() => {
        if (portal.current) {
            context.paginationPortal = portal.current
            if (!initialized.current) {
                initialized.current = true
                PaginationPortalLoaded.raise()
            } else {
                // Notify RequestPageRepeat when context changes (new context object created on parent re-render)
                PortalUpdated.raise()
            }
        }
    }, [context])

    return <Box ref={setPortal} flexShrink={0} {...props} />

    function setPortal(value) {
        if (!value || portal.current === value) return
        context.paginationPortal = value
        portal.current = value
        if (!initialized.current) {
            initialized.current = true
            PortalUpdated.raise()
            PaginationPortalLoaded.raise()
        }
    }
}
